import { fetchApi } from '@/config/axiosSetting';
import {
  GetPerformanceSummaryQueryParamsType,
  GetPerformanceSummaryQueryResponseType,
} from './getPerformanceSummaryQuery.type';

export const getPerformanceSummaryFunction = (
  params: GetPerformanceSummaryQueryParamsType,
): Promise<GetPerformanceSummaryQueryResponseType> =>
  fetchApi.get('/survey/performance_summery/', { params });
